<template><section>

<h2>Icon 图标</h2>
<p>语义化的矢量图形，内置<code v-pre="">uiw icons</code>图标属于UI框架常用图形字体。<a href="https://uiw-react.github.io/icons/" target="_blank">#uiw icons</a></p>
<h3>按需引入</h3>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">import</span> Vue <span class="hljs-keyword">from</span> <span class="hljs-string">'vue'</span>;
<span class="hljs-keyword">import</span> { Icon } <span class="hljs-keyword">from</span> <span class="hljs-string">'./components/icon'</span>;
<span class="hljs-keyword">import</span> <span class="hljs-string">'bin-vue/bindist/dist/icon/index.css'</span>;
Vue.component(Icon.name, Icon);
</code></pre>
<h3>如何使用</h3>
<p>指定图标对应的<code v-pre="">icon</code>属性，示例代码：</p>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">b-icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"circle-check"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"40"</span> <span class="hljs-attr">color</span>=<span class="hljs-string">"#ff0000"</span> <span class="hljs-attr">spin</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">b-icon</span>&gt;</span>
</code></pre>
<p>示例如下:</p>
<demo-block>
                <div class="source" slot="source"><div style="margin-right: 10px; display: inline-block;">
  <b-icon type="loading" spin=""></b-icon>
</div>
<div style="margin-right: 10px; display: inline-block;">
  <b-icon type="minus" color="#ff0000"></b-icon>
</div>
<div style="margin-right: 10px; display: inline-block;">
  <b-icon type="plus" size="18" color="#ff0000"></b-icon>
</div>
</div>
                <p>Icon 图标</p>

                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"margin-right: 10px; display: inline-block;"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">b-icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"loading"</span> <span class="hljs-attr">spin</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">b-icon</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"margin-right: 10px; display: inline-block;"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">b-icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"minus"</span> <span class="hljs-attr">color</span>=<span class="hljs-string">"#ff0000"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">b-icon</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"margin-right: 10px; display: inline-block;"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">b-icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"plus"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"18"</span> <span class="hljs-attr">color</span>=<span class="hljs-string">"#ff0000"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">b-icon</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>添加自己的图标字体方法</h3>
<p><code v-pre="">icon</code> 名字需要命名规范，必须加上前缀 <code v-pre="">.w-icon-图标名字</code></p>
<pre v-pre=""><code v-pre="" class="language-less"><span class="hljs-selector-tag">@font-face</span> {
  <span class="hljs-attribute">font-family</span>: <span class="hljs-string">"iconfont"</span>;
  <span class="hljs-attribute">src</span>: url(<span class="hljs-string">'iconfont.eot'</span>); <span class="hljs-comment">/* IE9*/</span>
  <span class="hljs-attribute">src</span>: url(<span class="hljs-string">'iconfont.eot'</span>) format(<span class="hljs-string">'embedded-opentype'</span>), <span class="hljs-comment">/* IE6-IE8 */</span>
  url(<span class="hljs-string">'iconfont.woff'</span>) format(<span class="hljs-string">'woff'</span>), <span class="hljs-comment">/* chrome, firefox */</span>
  url(<span class="hljs-string">'iconfont.ttf'</span>) format(<span class="hljs-string">'truetype'</span>), <span class="hljs-comment">/* chrome, firefox, opera, Safari, Android, iOS 4.2+*/</span>
  url(<span class="hljs-string">'iconfont.svg'</span>) format(<span class="hljs-string">'svg'</span>); <span class="hljs-comment">/* iOS 4.1- */</span>
}

<span class="hljs-selector-attr">[class^="w-icon-uiw-"]</span>, <span class="hljs-selector-attr">[class*=" w-icon-uiw-"]</span> {
  <span class="hljs-attribute">font-family</span>:<span class="hljs-string">"iconfont"</span> <span class="hljs-meta">!important</span>;
  <span class="hljs-attribute">font-size</span>:<span class="hljs-number">16px</span>;
  <span class="hljs-attribute">font-style</span>:normal;
  <span class="hljs-attribute">-webkit-font-smoothing</span>: antialiased;
  <span class="hljs-attribute">-moz-osx-font-smoothing</span>: grayscale;
}

<span class="hljs-selector-class">.w-icon-uiw-wxbgongju</span><span class="hljs-selector-pseudo">:before</span> { <span class="hljs-attribute">content</span>: <span class="hljs-string">"\e61b"</span>; }
<span class="hljs-selector-class">.w-icon-uiw-wxbmingxingdianpu</span><span class="hljs-selector-pseudo">:before</span> { <span class="hljs-attribute">content</span>: <span class="hljs-string">"\e61c"</span>; }
</code></pre>
<p>上面写好CSS之后在组件中引用，就可以通过 Icon 组件来调用了，例如上面定义了两个图标使用方法如下</p>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">b-icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"uiw-wxbgongju"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"20"</span> <span class="hljs-attr">color</span>=<span class="hljs-string">"#ff0000"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">b-icon</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">b-icon</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"uiw-wxbmingxingdianp"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"20"</span> <span class="hljs-attr">color</span>=<span class="hljs-string">"#ff0000"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">b-icon</span>&gt;</span>
</code></pre>
<p>注意：这里 <code v-pre="">.w-icon-</code> 是当前默认引用的字体文件，<code v-pre="">w-icon-uiw-</code> 是引用自己制作的字体文件，来覆盖默认的字体文件，就当成一个新的作用域。</p>
<h3>Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>type</td>
<td>图标的名称</td>
<td>string</td>
<td>—</td>
</tr>
<tr>
<td>size</td>
<td>字体大小单位px</td>
<td>string / number</td>
<td>18px</td>
</tr>
<tr>
<td>color</td>
<td>字体颜色</td>
<td>string</td>
<td>#999</td>
</tr>
<tr>
<td>spin</td>
<td>是否有旋转动画</td>
<td>boolean</td>
<td>false</td>
</tr>
</tbody>
</table>
<h3>图标旋转实例</h3>
<demo-block>
                <div class="source" slot="source"><template>
  <div>
    <b-grid column="6" :show-border="false">
      <b-grid-item :griditem-h="100" v-for="(item, index) in iconList" :key="index" style="padding:3px">
        <div class="demo-grid-box">
          <b-icon :type="item" size="20" spin=""></b-icon>
          <p>{{ item }}</p>
        </div>
      </b-grid-item>
    </b-grid>
  </div>
</template>


</div>
                <p>Icon 图标</p>

                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">b-grid</span> <span class="hljs-attr">column</span>=<span class="hljs-string">"6"</span> <span class="hljs-attr">:show-border</span>=<span class="hljs-string">"false"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">b-grid-item</span> <span class="hljs-attr">:griditem-h</span>=<span class="hljs-string">"100"</span> <span class="hljs-attr">v-for</span>=<span class="hljs-string">"(item, index) in iconList"</span> <span class="hljs-attr">:key</span>=<span class="hljs-string">"index"</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"padding:3px"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"demo-grid-box"</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">b-icon</span> <span class="hljs-attr">:type</span>=<span class="hljs-string">"item"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"20"</span> <span class="hljs-attr">spin</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">b-icon</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>{{ item }}<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">b-grid-item</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">b-grid</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span>  {
      <span class="hljs-attr">iconList</span>: [<span class="hljs-string">'loading'</span>, <span class="hljs-string">'reload'</span>, <span class="hljs-string">'picasa'</span>]
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>方向性图标</h3>
<demo-block>
                <div class="source" slot="source"><template>
  <div>
    <b-grid column="6" :show-border="false">
      <b-grid-item :griditem-h="100" v-for="(item, index) in iconList2" :key="index" style="padding:3px">
        <div class="demo-grid-box">
          <b-icon :type="item" size="20"></b-icon>
          <p>{{ item }}</p>
        </div>
      </b-grid-item>
    </b-grid>
  </div>
</template>


</div>
                <p>Icon 图标</p>

                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">b-grid</span> <span class="hljs-attr">column</span>=<span class="hljs-string">"6"</span> <span class="hljs-attr">:show-border</span>=<span class="hljs-string">"false"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">b-grid-item</span> <span class="hljs-attr">:griditem-h</span>=<span class="hljs-string">"100"</span> <span class="hljs-attr">v-for</span>=<span class="hljs-string">"(item, index) in iconList2"</span> <span class="hljs-attr">:key</span>=<span class="hljs-string">"index"</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"padding:3px"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"demo-grid-box"</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">b-icon</span> <span class="hljs-attr">:type</span>=<span class="hljs-string">"item"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"20"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">b-icon</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>{{ item }}<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">b-grid-item</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">b-grid</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span>  {
      <span class="hljs-attr">iconList2</span>: [
        <span class="hljs-string">'caret-down'</span>, <span class="hljs-string">'arrow-down'</span>,<span class="hljs-string">'down-square-o'</span>,<span class="hljs-string">'down-square'</span>,  <span class="hljs-string">'down-circle-o'</span>, <span class="hljs-string">'down-circle'</span>,
        <span class="hljs-string">'caret-up'</span>,<span class="hljs-string">'arrow-up'</span>, <span class="hljs-string">'up-square-o'</span>, <span class="hljs-string">'up-square'</span>,<span class="hljs-string">'up-circle-o'</span>,<span class="hljs-string">'up-circle'</span>, <span class="hljs-string">'caret-left'</span>,
        <span class="hljs-string">'arrow-left'</span>,<span class="hljs-string">'left-square-o'</span>,<span class="hljs-string">'left-square'</span>,  <span class="hljs-string">'left-circle-o'</span>, <span class="hljs-string">'left-circle'</span>, <span class="hljs-string">'caret-right'</span>,
        <span class="hljs-string">'arrow-right'</span>,<span class="hljs-string">'right-square-o'</span>, <span class="hljs-string">'right-square'</span>,<span class="hljs-string">'right-circle-o'</span>, <span class="hljs-string">'right-circle'</span>, <span class="hljs-string">'shrink'</span>,
        <span class="hljs-string">'arrows-alt'</span>,<span class="hljs-string">'d-arrow-left'</span>,<span class="hljs-string">'d-arrow-right'</span>,<span class="hljs-string">'enter'</span>, <span class="hljs-string">'rollback'</span>, <span class="hljs-string">'d-caret'</span>,<span class="hljs-string">'backward'</span>,
        <span class="hljs-string">'forward'</span>,  <span class="hljs-string">'logout'</span>, <span class="hljs-string">'login'</span>,  <span class="hljs-string">'swap-right'</span>, <span class="hljs-string">'swap'</span>, <span class="hljs-string">'verticle-left'</span>, <span class="hljs-string">'verticle-right'</span>,
        <span class="hljs-string">'play-circle-o'</span>,  <span class="hljs-string">'play-circle'</span>,<span class="hljs-string">'menu-fold'</span>, <span class="hljs-string">'menu-unfold'</span>
      ]
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>符号</h3>
<demo-block>
                <div class="source" slot="source"><template>
  <div>
    <b-grid column="6" :show-border="false">
      <b-grid-item :griditem-h="100" v-for="(item, index) in iconList3" :key="index" style="padding:3px">
        <div class="demo-grid-box">
          <b-icon :type="item" size="20"></b-icon>
          <p>{{ item }}</p>
        </div>
      </b-grid-item>
    </b-grid>
  </div>
</template>


</div>
                <p>Icon 图标</p>

                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">b-grid</span> <span class="hljs-attr">column</span>=<span class="hljs-string">"6"</span> <span class="hljs-attr">:show-border</span>=<span class="hljs-string">"false"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">b-grid-item</span> <span class="hljs-attr">:griditem-h</span>=<span class="hljs-string">"100"</span> <span class="hljs-attr">v-for</span>=<span class="hljs-string">"(item, index) in iconList3"</span> <span class="hljs-attr">:key</span>=<span class="hljs-string">"index"</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"padding:3px"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"demo-grid-box"</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">b-icon</span> <span class="hljs-attr">:type</span>=<span class="hljs-string">"item"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"20"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">b-icon</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>{{ item }}<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">b-grid-item</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">b-grid</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span>  {
      <span class="hljs-attr">iconList3</span>: [
        <span class="hljs-string">"plus"</span>, <span class="hljs-string">'plus-circle-o'</span>,<span class="hljs-string">'plus-circle'</span>, <span class="hljs-string">'plus-square'</span>, <span class="hljs-string">'plus-square-o'</span>, <span class="hljs-string">"question-circle-o"</span>, 
        <span class="hljs-string">"minus"</span>, <span class="hljs-string">'minus-circle-o'</span>, <span class="hljs-string">'minus-circle'</span>, <span class="hljs-string">'minus-square'</span>, <span class="hljs-string">'minus-square-o'</span>,<span class="hljs-string">"question-circle"</span>, 
        <span class="hljs-string">"close"</span>, <span class="hljs-string">"circle-close-o"</span>, <span class="hljs-string">"circle-close"</span>,<span class="hljs-string">'close-square'</span>, <span class="hljs-string">'close-square-o'</span>, <span class="hljs-string">"asterisk"</span>, 
        <span class="hljs-string">"check"</span>, <span class="hljs-string">"circle-check-o"</span>, <span class="hljs-string">"circle-check"</span>,<span class="hljs-string">'check-square'</span>,<span class="hljs-string">'check-square-o'</span>, <span class="hljs-string">"copyright"</span>,
      ]
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>文件</h3>
<demo-block>
                <div class="source" slot="source"><template>
  <div>
    <b-grid column="6" :show-border="false">
      <b-grid-item :griditem-h="100" v-for="(item, index) in iconList4" :key="index" style="padding:3px">
        <div class="demo-grid-box">
          <b-icon :type="item" size="20"></b-icon>
          <p>{{ item }}</p>
        </div>
      </b-grid-item>
    </b-grid>
  </div>
</template>


</div>
                <p>Icon 图标</p>

                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">b-grid</span> <span class="hljs-attr">column</span>=<span class="hljs-string">"6"</span> <span class="hljs-attr">:show-border</span>=<span class="hljs-string">"false"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">b-grid-item</span> <span class="hljs-attr">:griditem-h</span>=<span class="hljs-string">"100"</span> <span class="hljs-attr">v-for</span>=<span class="hljs-string">"(item, index) in iconList4"</span> <span class="hljs-attr">:key</span>=<span class="hljs-string">"index"</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"padding:3px"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"demo-grid-box"</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">b-icon</span> <span class="hljs-attr">:type</span>=<span class="hljs-string">"item"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"20"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">b-icon</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>{{ item }}<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">b-grid-item</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">b-grid</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span>  {
      <span class="hljs-attr">iconList4</span>: [
        <span class="hljs-string">'file-text'</span>, <span class="hljs-string">'file-jpg'</span>, <span class="hljs-string">'file-unknown'</span>, <span class="hljs-string">'file-add'</span>, <span class="hljs-string">'file-excel'</span>, <span class="hljs-string">'file-pdf'</span>,
        <span class="hljs-string">'folder-add'</span>, <span class="hljs-string">'folder-open'</span>, <span class="hljs-string">'paper-clip'</span>
      ]
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>其它</h3>
<demo-block>
                <div class="source" slot="source"><template>
  <div>
    <b-grid column="6" :show-border="false">
      <b-grid-item :griditem-h="100" v-for="(item, index) in iconList5" :key="index" style="padding:3px">
        <div class="demo-grid-box">
          <b-icon :type="item" size="20"></b-icon>
          <p>{{ item }}</p>
        </div>
      </b-grid-item>
    </b-grid>
  </div>
</template>


</div>
                <p>Icon 图标</p>

                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">b-grid</span> <span class="hljs-attr">column</span>=<span class="hljs-string">"6"</span> <span class="hljs-attr">:show-border</span>=<span class="hljs-string">"false"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">b-grid-item</span> <span class="hljs-attr">:griditem-h</span>=<span class="hljs-string">"100"</span> <span class="hljs-attr">v-for</span>=<span class="hljs-string">"(item, index) in iconList5"</span> <span class="hljs-attr">:key</span>=<span class="hljs-string">"index"</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"padding:3px"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"demo-grid-box"</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">b-icon</span> <span class="hljs-attr">:type</span>=<span class="hljs-string">"item"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"20"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">b-icon</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>{{ item }}<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">b-grid-item</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">b-grid</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span>  {
      <span class="hljs-attr">iconList5</span>: [
        <span class="hljs-string">'heart-off'</span>, <span class="hljs-string">'heart-on'</span>, <span class="hljs-string">'star-on'</span>, <span class="hljs-string">'star-off'</span>,<span class="hljs-string">'lock'</span>, <span class="hljs-string">'unlock'</span>,<span class="hljs-string">'dashboard'</span>,
        <span class="hljs-string">'area-chart'</span>, <span class="hljs-string">'bar-chart'</span>, <span class="hljs-string">'dot-chart'</span>,<span class="hljs-string">'pie-chart'</span>, 
        <span class="hljs-string">'dislike-o'</span>, <span class="hljs-string">'like-o'</span>,<span class="hljs-string">'loading'</span>, <span class="hljs-string">'reload'</span>,<span class="hljs-string">'appstore'</span>, <span class="hljs-string">'appstore-o'</span>,
        <span class="hljs-string">'tag'</span>, <span class="hljs-string">'tag-o'</span>,<span class="hljs-string">'tags'</span>,<span class="hljs-string">'tags-o'</span>, <span class="hljs-string">'setting'</span>,<span class="hljs-string">'setting-o'</span>,<span class="hljs-string">'map'</span>,<span class="hljs-string">'table'</span>,<span class="hljs-string">'qrcode'</span>,<span class="hljs-string">'barcode'</span>,<span class="hljs-string">'printer'</span>,
        <span class="hljs-string">'cloud-upload'</span>,<span class="hljs-string">'cloud-upload-o'</span>, <span class="hljs-string">'cloud-download'</span>,<span class="hljs-string">'cloud-download-o'</span>, <span class="hljs-string">'download'</span>,<span class="hljs-string">'message'</span>,<span class="hljs-string">'message-o'</span>,
        <span class="hljs-string">'user'</span>, <span class="hljs-string">'usergroup-add'</span>, <span class="hljs-string">'zoom-in'</span>, <span class="hljs-string">'zoom-out'</span>,<span class="hljs-string">'time'</span>, <span class="hljs-string">'time-o'</span>,
        <span class="hljs-string">"bell"</span>, <span class="hljs-string">'camera-o'</span>, <span class="hljs-string">'coffee'</span>, <span class="hljs-string">'document'</span>, <span class="hljs-string">'delete'</span>, <span class="hljs-string">'date'</span>, <span class="hljs-string">'edit'</span>,  <span class="hljs-string">'eye-o'</span>, <span class="hljs-string">'environment-o'</span>, 
        <span class="hljs-string">'filter'</span>, <span class="hljs-string">'global'</span>, <span class="hljs-string">'inbox'</span>, <span class="hljs-string">'home'</span>, <span class="hljs-string">'laptop'</span>, <span class="hljs-string">'link'</span>,  <span class="hljs-string">'menu'</span>, <span class="hljs-string">'mobile'</span>, <span class="hljs-string">'more'</span>, <span class="hljs-string">'notification'</span>, 
        <span class="hljs-string">'picture'</span>, <span class="hljs-string">'picasa'</span>, <span class="hljs-string">'pay-circle-o'</span>, <span class="hljs-string">'pay'</span>, <span class="hljs-string">'poweroff'</span>,  <span class="hljs-string">'save'</span>, <span class="hljs-string">'safety'</span>, <span class="hljs-string">'search'</span>, <span class="hljs-string">'shopping-cart'</span>, 
        <span class="hljs-string">'share'</span>,   <span class="hljs-string">'upload'</span>, <span class="hljs-string">'verification'</span>, <span class="hljs-string">'video-camera'</span>, <span class="hljs-string">'wifi'</span>
      ]
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>品牌标识</h3>
<demo-block>
                <div class="source" slot="source"><template>
  <div>
    <b-grid column="6" :show-border="false">
      <b-grid-item :griditem-h="100" v-for="(item, index) in iconList6" :key="index" style="padding:3px">
        <div class="demo-grid-box">
          <b-icon :type="item" size="20"></b-icon>
          <p>{{ item }}</p>
        </div>
      </b-grid-item>
    </b-grid>
  </div>
</template>


</div>
                <p>Icon 图标</p>

                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">b-grid</span> <span class="hljs-attr">column</span>=<span class="hljs-string">"6"</span> <span class="hljs-attr">:show-border</span>=<span class="hljs-string">"false"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">b-grid-item</span> <span class="hljs-attr">:griditem-h</span>=<span class="hljs-string">"100"</span> <span class="hljs-attr">v-for</span>=<span class="hljs-string">"(item, index) in iconList6"</span> <span class="hljs-attr">:key</span>=<span class="hljs-string">"index"</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"padding:3px"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"demo-grid-box"</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">b-icon</span> <span class="hljs-attr">:type</span>=<span class="hljs-string">"item"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"20"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">b-icon</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>{{ item }}<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">b-grid-item</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">b-grid</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span>  {
      <span class="hljs-attr">iconList6</span>: [
        <span class="hljs-string">'uiw'</span>, <span class="hljs-string">'windows'</span>, <span class="hljs-string">"linux"</span>, <span class="hljs-string">'apple'</span>, <span class="hljs-string">'facebook'</span>, <span class="hljs-string">'twitter'</span>, <span class="hljs-string">'adobe'</span>, <span class="hljs-string">"baidu"</span>, <span class="hljs-string">"ali-pay"</span>, 
        <span class="hljs-string">'android-o'</span>, <span class="hljs-string">'android'</span>,<span class="hljs-string">'reddit'</span>, <span class="hljs-string">'github'</span>, <span class="hljs-string">'github-o'</span>, <span class="hljs-string">"aliwangwang"</span>,   <span class="hljs-string">"dingding"</span>, 
        <span class="hljs-string">"foursquare"</span>, <span class="hljs-string">"linkedin"</span>, <span class="hljs-string">"pinterest"</span>, <span class="hljs-string">"qq"</span>,  <span class="hljs-string">"weibo"</span>, <span class="hljs-string">"taobao"</span>, <span class="hljs-string">"weixin"</span>, <span class="hljs-string">'css3'</span>, <span class="hljs-string">'html5'</span>
      ]
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>浏览器图标</h3>
<demo-block>
                <div class="source" slot="source"><template>
  <div>
    <b-grid column="6" :show-border="false">
      <b-grid-item :griditem-h="100" v-for="(item, index) in iconList7" :key="index" style="padding:3px">
        <div class="demo-grid-box">
          <b-icon :type="item" size="20"></b-icon>
          <p>{{ item }}</p>
        </div>
      </b-grid-item>
    </b-grid>
  </div>
</template>


</div>
                <p>Icon 图标</p>

                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">b-grid</span> <span class="hljs-attr">column</span>=<span class="hljs-string">"6"</span> <span class="hljs-attr">:show-border</span>=<span class="hljs-string">"false"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">b-grid-item</span> <span class="hljs-attr">:griditem-h</span>=<span class="hljs-string">"100"</span> <span class="hljs-attr">v-for</span>=<span class="hljs-string">"(item, index) in iconList7"</span> <span class="hljs-attr">:key</span>=<span class="hljs-string">"index"</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"padding:3px"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"demo-grid-box"</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">b-icon</span> <span class="hljs-attr">:type</span>=<span class="hljs-string">"item"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"20"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">b-icon</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>{{ item }}<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">b-grid-item</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">b-grid</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span>  {
      <span class="hljs-attr">iconList7</span>: [
        <span class="hljs-string">"chrome"</span>, <span class="hljs-string">"safari"</span>, <span class="hljs-string">"firefox"</span>, <span class="hljs-string">"opera"</span>, <span class="hljs-string">"ie"</span>
      ]
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
</section></template>
<style lang="less">
.demo-grid-box {
  height: 100%;
  background: #f4f4f4;
  display: flex;
  align-items: center;
  justify-content:center;
  flex-direction: column;
  p {
    margin-top: 10px;
  }
}
</style>
<script>
export default {
  data () {
    return  {
      iconList: ['loading', 'reload', 'picasa'],
      iconList2: [
        'caret-down', 'arrow-down','down-square-o','down-square',  'down-circle-o', 'down-circle',
        'caret-up','arrow-up', 'up-square-o', 'up-square','up-circle-o','up-circle', 'caret-left',
        'arrow-left','left-square-o','left-square',  'left-circle-o', 'left-circle', 'caret-right',
        'arrow-right','right-square-o', 'right-square','right-circle-o', 'right-circle', 'shrink',
        'arrows-alt','d-arrow-left','d-arrow-right','enter', 'rollback', 'd-caret','backward',
        'forward',  'logout', 'login',  'swap-right', 'swap', 'verticle-left', 'verticle-right',
        'play-circle-o',  'play-circle','menu-fold', 'menu-unfold'
      ],
      iconList3: [
        "plus", 'plus-circle-o','plus-circle', 'plus-square', 'plus-square-o', "question-circle-o", 
        "minus", 'minus-circle-o', 'minus-circle', 'minus-square', 'minus-square-o',"question-circle", 
        "close", "circle-close-o", "circle-close",'close-square', 'close-square-o', "asterisk", 
        "check", "circle-check-o", "circle-check",'check-square','check-square-o', "copyright",
      ],
      iconList4: [
        'file-text', 'file-jpg', 'file-unknown', 'file-add', 'file-excel', 'file-pdf',
        'folder-add', 'folder-open', 'paper-clip'
      ],
      iconList5: [
        'heart-off', 'heart-on', 'star-on', 'star-off','lock', 'unlock','dashboard',
        'area-chart', 'bar-chart', 'dot-chart','pie-chart', 
        'dislike-o', 'like-o','loading', 'reload','appstore', 'appstore-o',
        'tag', 'tag-o','tags','tags-o', 'setting','setting-o','map','table','qrcode','barcode','printer',
        'cloud-upload','cloud-upload-o', 'cloud-download','cloud-download-o', 'download','message','message-o',
        'user', 'usergroup-add', 'zoom-in', 'zoom-out','time', 'time-o',
        "bell", 'camera-o', 'coffee', 'document', 'delete', 'date', 'edit',  'eye-o', 'environment-o', 
        'filter', 'global', 'inbox', 'home', 'laptop', 'link',  'menu', 'mobile', 'more', 'notification', 
        'picture', 'picasa', 'pay-circle-o', 'pay', 'poweroff',  'save', 'safety', 'search', 'shopping-cart', 
        'share',   'upload', 'verification', 'video-camera', 'wifi'
      ],
      iconList6: [
        'uiw', 'windows', "linux", 'apple', 'facebook', 'twitter', 'adobe', "baidu", "ali-pay", 
        'android-o', 'android','reddit', 'github', 'github-o', "aliwangwang",   "dingding", 
        "foursquare", "linkedin", "pinterest", "qq",  "weibo", "taobao", "weixin", 'css3', 'html5'
      ],
      iconList7: [
        "chrome", "safari", "firefox", "opera", "ie"
      ]
    }
  }
}
</script>